import { lazy, Suspense, useRef } from "react";
import DotGridGlow from "@/components/DotGridGlow";
import Feet from "@/components/Feet";
import FollowUs from "@/components/FollowUs";
import Hero from "@/components/pages/home/Hero";
import NewHeader from "@/components/NewHeader";
import OurMission from "@/components/pages/home/OurMission";
import OurPortfolio from "@/components/pages/home/OurPortfolio";
import OurServices from "@/components/pages/home/OurServices";
import OurPartners from "@/components/pages/home/Partners";
import WhyLuminode from "@/components/pages/home/WhyLuminode";
import BigEllipse from "@/components/svg/ellipse/BigEllipse";
import MediumEllipse from "@/components/svg/ellipse/MediumEllipse";

const WorkWithUs = lazy(() => import("@/components/WorkWithUs"));

export function Home() {
  const home = useRef(null);
  const expertises = useRef(null);
  const mission = useRef(null);
  const advantage = useRef(null);
  const team = useRef(null);

  return (
    <div className="flex flex-col items-center justify-start bg-[#090910] gap-[100px] relative isolate overflow-clip">
      <DotGridGlow />
      <div className="absolute top-[-600px]">
        <MediumEllipse />
      </div>
      <div className="absolute top-[-0px] left-[-800px] pointer-events-none">
        <BigEllipse />
      </div>
      <NewHeader reflist={[home, expertises, mission, advantage, team]} />
      <Hero ref0={home} />
      <OurPartners />
      <OurServices ref0={expertises} />
      <OurMission ref0={mission} />
      <OurPortfolio />
      <WhyLuminode ref0={advantage} />
      <FollowUs ref0={team} />
      <Suspense fallback={null}>
        <WorkWithUs />
      </Suspense>
      <Feet />
    </div>
  );
}
